import { render, staticRenderFns } from "./refund_ticket.vue?vue&type=template&id=12d8801c&scoped=true&"
import script from "./refund_ticket.vue?vue&type=script&lang=js&"
export * from "./refund_ticket.vue?vue&type=script&lang=js&"
import style0 from "./refund_ticket.vue?vue&type=style&index=0&id=12d8801c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d8801c",
  null
  
)

export default component.exports